import * as React from 'react';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import * as Api from 'src/api';
import ModuleForm from 'src/components/Module/form';

class ModuleCreateContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentId: this.props.match.params.contentId,
      module: {
        style: '',
        translations: {
          cn: {
            title: null,
            link: null,
            linkTitle: null,
          },
          es: {
            title: null,
            link: null,
            linkTitle: null,
          },
          en: {
            title: null,
            link: null,
            linkTitle: null,
          },
          pt: {
            title: null,
            link: null,
            linkTitle: null,
          },
          fr: {
            title: null,
            link: null,
            linkTitle: null,
          },
          it: {
            title: null,
            link: null,
            linkTitle: null,
          },
        },
        content_id: this.props.match.params.contentId,
        type: 'ABOUT',
        data: {
          contentsSearch: {
            type: null,
            subtype_id: null,
            destination: null,
            tags: [],
            limit: 10,
          },
          destinationsActivities: [],
          tags: [],
          cards: [],
          cardsFormat: 'horizontal',
          contents: [],
          activities: [],
          images: [],
          imagesFormat: 'simple',
          destinations: [],
          destinationsFormat: 'detail',
          companyId: null,
          cardId: null,
          bankId: null,
          coefficient: null,
          installments: [],
          search: 'test',
          days: [],
          nights: [],
          packageDestinations: [],
          packageCountries: [],
          packageRegions: [],
          packagesOptions: {
            tags: 'in',
            destinations: 'in',
          },
          currency: 'ARS',
          pageSize: 10,
          locale: 'es',
          departure: {
            id: 129,
            name: 'Buenos Aires',
            code: 'BUE',
          },
          nationality: 'AR',
          text: {
            type: null,
            es: {
              text: null,
              shortDescription: null,
            },
            en: {
              text: null,
              shortDescription: null,
            },
            pt: {
              text: null,
              shortDescription: null,
            },
            fr: {
              text: null,
              shortDescription: null,
            },
            cn: {
              text: null,
              shortDescription: null,
            },
            it: {
              text: null,
              shortDescription: null,
            },
          },
          packages: [],
          packagesFormat: 'horizontal',
          columns: null,
          breadcrumbs: {
            es: [],
            en: [],
            fr: [],
            pt: [],
            cn: [],
            it: [],
          },
          type: null,
          hotels: {
            destination: null,
            recommended: false,
            category: null,
            hotel: null,
            type: null,
          },
        },
      },
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  public async onSubmit(body: any): Promise<void> {console.log(body);
    await Api.createModule(body);

    toast.success('El registro fue creado con éxito');
    return this.props.history.push(`/modulos/${this.state.contentId}`);
  }

  public render() {
    return (
      <ModuleForm
        module={this.state.module}
        onSubmit={this.onSubmit}
        contentId={this.state.contentId}
      />
    );
  }
}

export default withRouter(ModuleCreateContainer);



// WEBPACK FOOTER //
// ./src/containers/Module/create.tsx